import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { CKEDITORCONFIG } from '../ckeditor-config';
import { GmailMessage } from '../gmail-message';
import { GmailService } from '../service/gmail.service';
import { HttpService } from '../service/http.service';
import { ToastMessageService } from '../toast-message.service';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-test-gmail-api',
  templateUrl: './test-gmail-api.component.html',
  styleUrls: ['./test-gmail-api.component.css']
})
export class TestGmailApiComponent implements OnInit, AfterViewInit {

  @ViewChild("editor") editor: any;

  public Editor = Editor;

  constructor(
    private gmailService: GmailService,
    private httpService: HttpService,
    private toastService: ToastMessageService
  ) { }

  emailBody = "";
  editorConfig = CKEDITORCONFIG;

  ngAfterViewInit(){
    console.log(this.editor);
  }
  ngOnInit(): void {

  }

  sendTestEmail(){
    let message = new GmailMessage(["accounts@languesvivantes.com"], "Gmail testing" + moment(), this.emailBody);
    // let encodedMessage = this.gmailService.getFormData(message, []);
    this.httpService.testHtmlEmailByGoogle(message).subscribe(() => {
      this.toastService.addSuccess("Success", "message sent");
    });
  }

}
